import React, { useEffect, useState } from 'react';
import { API, pacienteJsonHeaders } from '../../services/pacienteConfig';
import { PacienteTabNavigation } from '../../components/paciente/PacientePortalNav';
import './PacienteTurnosPage.css';

const PacienteTurnosPage = () => {
  const [turnos, setTurnos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const [modalConfig, setModalConfig] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);

  useEffect(() => {
    fetchTurnos();
  }, []);

  const fetchTurnos = async () => {
    setLoading(true);
    setErrorMsg(null);
    try {
      const resp = await fetch(`${API}/paciente/turnos`, {
        headers: pacienteJsonHeaders(),
      });
      const data = await resp.json();
      if (data.success) {
        setTurnos(data.data);
      }
    } catch (e) {
      console.error(e);
      setErrorMsg('No se pudieron cargar los turnos.');
    } finally {
      setLoading(false);
    }
  };

  const formatFecha = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('es-AR', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const formatHora = (dateStr) => {
    return new Date(dateStr).toLocaleTimeString('es-AR', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const openConfirmModal = (turno) => {
    setModalConfig({
      type: 'confirmar',
      turnoId: turno.id,
      title: 'Confirmar turno',
      text: `Confirmas tu turno del ${formatFecha(turno.start)} a las ${formatHora(turno.start)}?`,
    });
  };

  const openCancelModal = (turno) => {
    setModalConfig({
      type: 'cancelar',
      turnoId: turno.id,
      title: 'Cancelar turno',
      text: `Seguro que queres cancelar tu turno del ${formatFecha(turno.start)} a las ${formatHora(turno.start)}? No podras revertir esta accion desde el portal.`,
    });
  };

  const handleAction = async () => {
    if (!modalConfig) return;
    setActionLoading(true);
    const { type, turnoId } = modalConfig;
    try {
      const resp = await fetch(`${API}/paciente/turnos/${turnoId}/${type}`, {
        method: 'POST',
        headers: pacienteJsonHeaders(),
      });
      const data = await resp.json();
      if (data.success) {
        setModalConfig(null);
        fetchTurnos();
      } else {
        setErrorMsg(data.message || 'Error al procesar la accion');
      }
    } catch (e) {
      setErrorMsg('Error de conexion');
    } finally {
      setActionLoading(false);
    }
  };

  return (
    <div className="paciente-turnos-page">
      <header className="pt-header">
        <h2>Mis Proximos Turnos</h2>
      </header>

      <div className="pt-content">
        {errorMsg && <div className="pt-error">{errorMsg}</div>}
        {loading ? (
          <div className="pt-loading">Cargando turnos...</div>
        ) : turnos.length === 0 ? (
          <div className="pt-empty">
            <h3>No tenes turnos proximos</h3>
            <p>Tus proximos turnos asignados apareceran aqui.</p>
          </div>
        ) : (
          <div className="pt-list">
            {turnos.map((turno) => (
              <div key={turno.id} className="pt-card">
                <div className="pt-card-header">
                  <div className="pt-date">
                    <span className="pt-day">{formatFecha(turno.start)}</span>
                    <span className="pt-time">{formatHora(turno.start)} hs</span>
                  </div>
                  <div
                    className={`pt-status ${
                      turno.confirmado ? 'confirmado' : turno.cancelado ? 'cancelado' : 'pendiente'
                    }`}
                  >
                    {turno.confirmado ? 'Confirmado' : turno.cancelado ? 'Cancelado' : 'Pendiente'}
                  </div>
                </div>

                <div className="pt-profesional">
                  <span
                    className="pt-prof-icon"
                    style={{ backgroundColor: turno.profesional_relacion?.color || '#C7CDD6' }}
                  >
                    {turno.profesional_relacion?.nombre?.charAt(0) || 'P'}
                  </span>
                  <div>
                    <p className="pt-prof-name">
                      Od. {turno.profesional_relacion?.nombre} {turno.profesional_relacion?.apellido}
                    </p>
                  </div>
                </div>

                {!turno.cancelado && !turno.confirmado && (
                  <div className="pt-actions">
                    <button type="button" className="pt-btn-cancel" onClick={() => openCancelModal(turno)}>
                      Cancelar
                    </button>
                    <button type="button" className="pt-btn-confirm" onClick={() => openConfirmModal(turno)}>
                      Confirmar
                    </button>
                  </div>
                )}
                {turno.confirmado && !turno.cancelado && (
                  <div className="pt-actions">
                    <button
                      type="button"
                      className="pt-btn-cancel full-width"
                      onClick={() => openCancelModal(turno)}
                    >
                      Cancelar turno
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {modalConfig && (
        <div className="pt-modal-overlay">
          <div className="pt-modal" role="dialog" aria-modal="true">
            <h3>{modalConfig.title}</h3>
            <p>{modalConfig.text}</p>
            <div className="pt-modal-actions">
              <button
                type="button"
                className="pt-modal-cancel"
                onClick={() => setModalConfig(null)}
                disabled={actionLoading}
              >
                Volver
              </button>
              <button
                type="button"
                className={`pt-modal-confirm ${modalConfig.type === 'cancelar' ? 'danger' : ''}`}
                onClick={handleAction}
                disabled={actionLoading}
              >
                {actionLoading
                  ? 'Procesando...'
                  : modalConfig.type === 'cancelar'
                    ? 'Si, cancelar'
                    : 'Si, confirmar'}
              </button>
            </div>
          </div>
        </div>
      )}

      <PacienteTabNavigation activeTab="turnos" />
    </div>
  );
};

export default PacienteTurnosPage;
